/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ─── Hero Parallax ────────────────────────────────────────────────────────────
// El scale(1.2) está fijo en CSS en el .Slideshow__ImageContainer[data-parallax].
// Este JS solo agrega translateY al mismo container al hacer scroll.
// Flickity nunca toca el ImageContainer → sin race conditions ni zoom brusco.
(function () {
    'use strict';

    if (window.matchMedia('(max-width: 640px)').matches) return;

    var parallaxTargets = [];
    var rafScheduled = false;
    var PARALLAX_FACTOR = 0.3;

    function gatherTargets() {
        parallaxTargets = Array.prototype.slice.call(
            document.querySelectorAll('.Slideshow__ImageContainer[data-parallax]')
        );
    }

    function applyParallax() {
        var scrollY = window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
        var vh = window.innerHeight;

        parallaxTargets.forEach(function (el) {
            var slide = el.closest('.Slideshow__Slide');
            var rect = slide ? slide.getBoundingClientRect() : el.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top > vh) return;
            // solo translateY — el scale(1.2) vive en CSS y nunca se toca
            var offset = (scrollY * PARALLAX_FACTOR).toFixed(2);
            el.style.transform = 'translateY(' + offset + 'px) scale(1.2)';
        });

        rafScheduled = false;
    }

    function onScroll() {
        if (!rafScheduled) {
            requestAnimationFrame(applyParallax);
            rafScheduled = true;
        }
    }

    function init() {
        gatherTargets();
        if (parallaxTargets.length === 0) return;
        window.addEventListener('scroll', onScroll, { passive: true });
        applyParallax(); // estado inicial: translateY(0) scale(1.2) — mismo que CSS
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// ─── Quick Add — ATC desde catalog ─────────────────────────────────────────
(function () {
    'use strict';

    function handleQuickAdd(e) {
        var btn = e.target.closest('button.ProductItem__QuickAdd[data-variant-id]');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.dataset.variantId;
        if (!variantId || btn.disabled) return;

        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = '...';

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
        })
            .then(function (res) { return res.json(); })
            .then(function () {
                btn.textContent = '✓ Agregado';
                // Dispara el evento del tema para refrescar el mini-cart/drawer
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                setTimeout(function () {
                    btn.textContent = originalText;
                    btn.disabled = false;
                }, 1800);
            })
            .catch(function () {
                btn.textContent = 'Error';
                setTimeout(function () {
                    btn.textContent = originalText;
                    btn.disabled = false;
                }, 1800);
            });
    }

    document.addEventListener('click', handleQuickAdd);
})();

// ─── Mobile: single-product carousels with dots ──────────────────────────────
// On mobile (< 1008px), the Prestige theme disables Flickity and uses native
// CSS horizontal scroll. This script adds dot indicators for those carousels.
(function () {
    'use strict';

    if (window.innerWidth > 640) return;

    function setupDots(section) {
        var carousel = section.querySelector('.ProductList--carousel');
        if (!carousel) return;

        var cells = carousel.querySelectorAll('.Carousel__Cell');
        if (cells.length <= 1) return;

        // Don't add dots twice
        if (section.querySelector('.MobileCarousel__Dots')) return;

        // Create dots container
        var dotsContainer = document.createElement('div');
        dotsContainer.className = 'MobileCarousel__Dots';

        cells.forEach(function (_, i) {
            var dot = document.createElement('button');
            dot.className = 'MobileCarousel__Dot' + (i === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Producto ' + (i + 1));

            dot.addEventListener('click', function () {
                cells[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            });

            dotsContainer.appendChild(dot);
        });

        // Insert dots after the ProductListWrapper
        var wrapper = section.querySelector('.ProductListWrapper');
        if (wrapper) {
            wrapper.parentNode.insertBefore(dotsContainer, wrapper.nextSibling);
        }

        // Track scroll to update active dot
        var scrollTimer;
        carousel.addEventListener('scroll', function () {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function () {
                var scrollLeft = carousel.scrollLeft;
                var cellWidth = cells[0].offsetWidth;
                var activeIndex = Math.round(scrollLeft / cellWidth);
                var dots = dotsContainer.querySelectorAll('.MobileCarousel__Dot');
                dots.forEach(function (dot, i) {
                    dot.classList.toggle('is-active', i === activeIndex);
                });
            }, 50);
        });
    }

    function initAll() {
        var sectionTypes = ['product-recommendations', 'recently-viewed-products'];
        sectionTypes.forEach(function (type) {
            var section = document.querySelector('[data-section-type="' + type + '"]');
            if (section) setupDots(section);
        });
    }

    // Init after DOM ready + delay for async sections
    function init() {
        initAll();
        // Recently viewed loads async — watch for it
        var observer = new MutationObserver(function () {
            initAll();
        });
        var body = document.querySelector('body');
        if (body) {
            observer.observe(body, { childList: true, subtree: true });
            // Stop observing after 10 seconds to avoid performance impact
            setTimeout(function () { observer.disconnect(); }, 10000);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(init, 500);
        });
    } else {
        setTimeout(init, 500);
    }
})();